import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M33.333 7.556H6.667A2.667 2.667 0 0 0 4 10.222v19.556a2.667 2.667 0 0 0 2.667 2.666h26.666A2.667 2.667 0 0 0 36 29.778V10.222a2.667 2.667 0 0 0-2.667-2.666ZM12.89 27.778c0 .366-.3.666-.667.666h-4a.669.669 0 0 1-.666-.666v-2.223c0-.366.3-.666.666-.666h4c.367 0 .667.3.667.666v2.223Zm10.667 0c0 .366-.3.666-.667.666h-7.556a.669.669 0 0 1-.666-.666v-2.223c0-.366.3-.666.666-.666h7.556c.367 0 .667.3.667.666v2.223Z" })
});
export default SvgCreditCard;
